module.exports = __webpack_public_path__ + "assets/images/slope-babies/mobile.svg?v=61877809";